import _ from 'lodash';

import { constants as savedViewConstants } from '../components/header/v2/saved_views';

const { BUTTON_TYPE } = savedViewConstants;

export const getItemIcon = isPrivate => (isPrivate ? 'lock' : 'users');

export const getDefaultview = title => ({ icon: 'users', label: title, value: 'defaultView' });

export const hasSetFilters = filters => {
  let result = false;
  _.forEach(_.values(filters), value => {
    if (!result && !_.isEmpty(value)) {
      result = true;
    }
  });
  return result;
};

export const mapSavedViewsItems = savedViews =>
  _.map(savedViews, element => ({
    ...element,
    icon: getItemIcon(element.private),
    options: [
      {
        label: 'Delete',
        theme: 'warning',
        value: BUTTON_TYPE.DELETE,
      }, // TODO add a missing possibility to rename the view
    ],
  }));

export const getSetFiltersCount = filters =>
  _.reduce(
    _.values(filters),
    (prevValue, currValue) => (!_.isEmpty(currValue) ? prevValue + 1 : prevValue),
    0,
  );

export const shouldShowSaveViewButton = (currentViewFilters, filters) =>
  (!currentViewFilters && hasSetFilters(filters)) ||
  (!hasSetFilters(currentViewFilters) && hasSetFilters(filters)) ||
  (hasSetFilters(currentViewFilters) && !hasSetFilters(filters)) ||
  (hasSetFilters(currentViewFilters) &&
    hasSetFilters(filters) &&
    !_.isEqual(currentViewFilters, filters));
